<template>
  <div class="bg-white p-4">
    <!-- <b-modal id="modal-1" title="Edit Music" hide-footer>
      <b-form role="form" @submit.prevent="handleSubmit">
        <div>
          <div class="mt-4">
            <FileUploader
              v-show="!image"
              :image="image"
              :onSuccess="handleSuccess"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            />
            <img
              v-if="image"
              :src="image"
              ref="cover"
              class="rounded-full widtht30percent m-auto display-none custmodal"
            />
            <div
              class="text-center text-red"
              v-if="image"
              @click="handleRemove"
            >
              Remove image
            </div>
            <p class="text-center">Upload your cover photo</p>
          </div>
          <b-form-group label="Music name">
            <base-input
              v-model="Music"
              placeholder="Music name"
              name="Music"
            ></base-input>
          </b-form-group>
          <b-form-group label="Producer">
            <base-input
              v-model="producer"
              placeholder="Enter Producer name"
              name="Producer"
            ></base-input>
          </b-form-group>

          <div class="">
            <p>Select File</p>
            <b-form-file
              v-model="file1"
              :state="Boolean(file1)"
              placeholder="Choose a file or drop it here..."
              drop-placeholder="Drop file here..."
            ></b-form-file>
          </div>

          <div class="flex justify-center mt-2">
            <b-button type="submit" variant="primary">Save</b-button>
          </div>
        </div>
      </b-form>
    </b-modal> -->
    <div class="flex justify-between items-center pt-4 pb-10">
      <div>
        <h2 class="text-2xl font-semibold">Meditation</h2>

        <small class="text-muted">Add you music</small>
      </div>

      <div>
        <base-button
          outline
          v-b-modal.modal-10
          class="px-6 py-1 mx-1"
          type="primary"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
            Music</span
          >
        </base-button>
        <b-modal id="modal-10" title="Add Music" hide-footer>
          <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
            <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
              <div>
                <div class="mt-4">
                  <FileUploader
                    v-show="!image"
                    :image="image"
                    :onSuccess="handleSuccess"
                    accept="image"
                    class="rounded-full widtht30percent m-auto display-none custmodal"
                  />
                  <img
                    v-if="image"
                    :src="image"
                    ref="cover"
                    class="rounded-full widtht30percent m-auto display-none custmodal"
                  />
                  <div
                    class="text-center text-red"
                    v-if="image"
                    @click="handleRemove"
                  >
                    Remove image
                  </div>
                  <p class="text-center">Upload your cover photo</p>
                  <span v-if="imageErr" class="small text-danger">{{
                    msg.image
                  }}</span>
                </div>
                <b-form-group label="Music name">
                  <base-input
                    v-model="name"
                    placeholder="Music name"
                    name="Music name"
                    :rules="{ required: true }"
                  ></base-input>
                </b-form-group>
                <!-- <b-form-group label="Producer">
                <base-input
                  v-model="producer"
                  placeholder="Enter Producer name"
                  name="Producer"
                ></base-input>
              </b-form-group> -->

                <div class="">
                  <p>Select Music</p>
                  <b-form-file
                    v-model="song"
                    accept="audio/*"
                    required
                    @change="filesChange"
                    placeholder="Choose a file or drop it here..."
                    drop-placeholder="Drop file here..."
                  ></b-form-file>
                  <span v-if="audioErr" class="small text-danger">{{
                    msg.audio
                  }}</span>
                </div>

                <div class="flex justify-center mt-2">
                  <b-button type="submit" variant="primary">Save</b-button>
                </div>
              </div>
            </b-form>
          </validation-observer>
        </b-modal>
      </div>
    </div>
    <!-- <div class="flex gap-4">
      <div class="w-full">
        <b-input-group class="">
          <b-form-input
            class="border-none shadow-lg"
            type="text"
            v-model="search"
            placeholder="Enter Search...."
          ></b-form-input>

          <b-input-group-append>
            <b-button
              variant="white"
              class="flex items-center shadow-lg"
              aria-label="search"
            >
              <feather-icon
                class="cursor-pointer mr-2"
                icon="SearchIcon"
                svgClasses="w-4 h-4"
              ></feather-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </div>
    </div> -->
    <MeditationTable ref="getMedi" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import _ from "lodash";

import MeditationTable from "./components/MeditationTable.vue";
import FileUploader from "../../../../components/FileUploader.vue";
export default {
  components: {
    MeditationTable,
    FileUploader,
  },
  data() {
    return {
      name: "",
      song: null,
      image: null,
      coverImage: null,
      imageErr: false,
      audioErr: false,
      msg: {
        image: "",
        audio: "",
      },
    };
  },
  methods: {
    filesChange(event) {
      // console.log(this.icone);
      // console.log(data);
      let mByte = 5 * 1048576;
      if (event.target.files[0].size > mByte) {
        this.song = null;
        event = {};
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          // text: "Please ensure that the file size does not exceed 5MB",
          html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          confirmButtonText: "Okay",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        this.audioErr = true;
        this.msg.audio = "File size exceeds the allowed limit!";
        // return;
      } else {
        this.audioErr = false;
        if (!event.target.files[0].type.includes("audio")) {
          this.song = null;
          event = {};
          this.audioErr = true;
          this.msg.audio = "Upload Audio File Only";
        } else {
          this.audioErr = false;
          this.song = event.target.files[0];
        }
      }
    },
    handleSuccess(image) {
      let mByte = 5 * 1048576;
      this.imageErr = false;
      if (!image.type.includes("image")) {
        this.imageErr = true;
        this.msg.image = "Upload Image Only";
      } else {
        this.imageErr = false;
        if (image.size > mByte) {
          this.$swal.fire({
            title: "File size exceeds the allowed limit!",
            // text: "Please ensure that the file size does not exceed 5MB",
            html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
            confirmButtonText: "Okay",
            icon: "warning",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          return;
        }
        this.coverImage = image;
        this.readerData(image);
      }
      // this.coverImage = image;
      // this.readerData(image);
    },
    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    async onSubmit() {
      this.name = this.name.trim();
      if (this.audioErr) {
        return;
      }
      if (this.coverImage === null) {
        await this.$swal({
          text: "Please upload cover photo!",
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#830c81",
        });
        return;
      }

      const payload = new FormData();
      payload.append("name", this.name);

      payload.append("song", this.song);
      // payload.append("image", this.coverImage);
      if (this.coverImage && this.image.slice(0, 4) === "data") {
        // console.log("image updated");
        payload.append("image", this.coverImage);
      }

      let loader;

      try {
        // console.log(payload);
        loader = this.$loading();
        const createMeditation = await this.$store.dispatch(
          "meditation/createMeditation",
          payload
        );

        if (createMeditation.code === 200) {
          // console.log(createMeditation);
          loader.close();
          this.closeModal();
          this.getMeditationFromTable();
          await this.$swal({
            text: "Meditation Added Successfully!",
            icon: "success",
            showCancelButton: false,
            confirmButtonColor: "#830c81",
          });

          this.name = "";
          this.song = null;
          this.coverImage = null;
          this.image = null;
          this.audioErr = false;
        }
        loader.close();
      } catch (error) {
        loader.close();
        console.log(error);
      }
    },
    closeModal() {
      this.$nextTick(() => {
        this.$bvModal.hide("modal-10");
      });
    },
    getMeditationFromTable() {
      this.$refs.getMedi.getMeditation();
    },
  },
};
</script>

<style>
.modal-header {
  display: flex !important;
  align-items: center !important;
  background-color: #4f0a4b !important;
  border-color: #4f0a4b !important;
  padding: 10px !important;
}

.modal-title {
  font-size: 20px !important;
  color: #fff !important;
}
.form-group {
  margin-bottom: 0.5rem;
}
input.is-invalid ~ .custom-file-label {
  border-color: #cad1d7;
}
.widtht30percent {
  width: 30%;
  height: 140px !important;
}
</style>
